import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { BaseService } from '@services/BaseService';
import { environment } from '@environments/environment';
//import { EmployeeModel } from '@models/EmployeeModel';
//import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class SecurityService {
  //baseService: BaseService;
  hcte: HttpClient;
  hs: HttpHeaders;
  //httopt: any;
  //type: string;
  //protected apiUrlBase: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  //protected apiUrlBase$: Observable<string> = environment.authApiServerUrl;
 // apiUrl = environment.authApiServerUrl;


  constructor(hcte: HttpClient) {
   // this.baseService = baseService;
    this.hcte = hcte;
    this.hs = new HttpHeaders();
    //this.hs.append('Content-Type', 'application/json');
  }

  //public GetAuthToken(role: string) {
  //  var r = environment.roles.find(x => x.name == role);
  //  //var data = 'username=AdminFM&password=adminfm%40inl.it&client_id=ca9a3ea6d791457d8422715ccfc70dce&grant_type=password';
  //  var data = "username=" + r.user + "&password=" + r.password + "&grant_type=password&client_id=" + environment.audienceId;
  //  //var data = { username: r.user, password: r.password, grant_type: 'password', client_id: environment.audienceId };
  //  //var data = new HttpParams().set('username', r.name).set('password', r.password).set('grant_type', 'password').set('client_id', environment.audienceId);
  //  //let data = new URLSearchParams();
  //  //data.set('username', r.user);
  //  //data.set('password', 'adminfm@inl.it');
  //  //data.set('grant_type', 'password');
  //  //data.set('client_id', environment.audienceId);
  //  this.hs.append('Content-Type', 'application/x-www-form-urlencoded');
  //  //const data = new FormData();
  //  //data.append('username', 'AdminFM');
  //  //data.append('password', 'adminfm@inl.it');
  //  //data.append('grant_type', 'password');
  //  //data.append('client_id', 'ca9a3ea6d791457d8422715ccfc70dce');
  //  //this.hs.append("cache-control", "no-cache");
  //  //this.hs.append("Postman-Token", "4ab1dd96-e0f7-403e-87b0-e26a06045773");
  //  //return this.baseService.Post(environment.authApiServerUrl,"", data.toString(), { headers: this.hs });


  //  var ur = environment.authApiServerUrl;
  //  var _rsult = this.hcte.post(ur, data, { headers: this.hs }).toPromise();
  //  _rsult.then((data) => {
  //    return data;
  //  });
  //  return _rsult;

  //  //const promise = this.hcte.post(this.apiUrl, data, { headers: this.hs }).toPromise();

  //  //promise.then((data) => {
  //  //  return data;
  //  //})

  // // var _rsult = this.hcte.post(environment.authApiServerUrl, data, { headers: this.hs });
  //}

    public GetAuthToken(role: string) {
       /* try {*/
            const r = environment.roles.find(x => x.name === role);
            const data = `username=${r.user}&password=${r.password}&grant_type=password&client_id=${environment.audienceId}`;
            this.hs.append('Content-Type', 'application/x-www-form-urlencoded');
            return this.hcte.post(environment.authApiServerUrl, data, { headers: this.hs });
        //} catch (e) {
        //    console.log(e);
        //}
    
    //  return 'http://localhost:4200/#/Access/RegisterAccess?token=%7B%22access_token%22:%22eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1laWQiOiI4OTNiM2Y5ZC0yODRhLTQ4ZDAtYWZhMC1iMGNkOTNlZGM1ODkiLCJ1bmlxdWVfbmFtZSI6ImlubC5maW5hbmNpYWxNb2QiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL2FjY2Vzc2NvbnRyb2xzZXJ2aWNlLzIwMTAvMDcvY2xhaW1zL2lkZW50aXR5cHJvdmlkZXIiOiJBU1AuTkVUIElkZW50aXR5IiwiQXNwTmV0LklkZW50aXR5LlNlY3VyaXR5U3RhbXAiOiI3ZTdkOWZmZi1iY2E5LTQyOWUtODc4OS00ZTE2ZTI1ZTI1MmEiLCJyb2xlIjpbIldlYkNsaWVudCIsIkFjY291bnRhbnQiLCJBZG1pbkZNIiwiRVRMIl0sImlzcyI6IkRtWHlQSjdQZms3dmpMOGgiLCJhdWQiOiIwODM1NmFhNGM1NDU0OWJjYjVjMTcwN2UxNjMyODljYSIsImV4cCI6MTc0MjYxMzMzOSwibmJmIjoxNzQyNTg0NTM5fQ.k0aYyAA8AX6NOPalF_1D1sJ26YxBh34AOPEC4Dx8ZsE%22,%22token_type%22:%22bearer%22,%22expires_in%22:%2228799%22,%22account%22:%22marinv1%22,%22role%22:%22AdminFM%22%7D';
  }

  //public GetAuthTokenMasterData() {
  //  const data = `username=${environment.MDUser}&password=${environment.MDPaswd}&grant_type=password&client_id=${environment.MDaudienceid}`;
  //  this.hs.append('Content-Type', 'application/x-www-form-urlencoded');
  //  return this.hcte.post(environment.masterDataServiceUrl, data, { headers: this.hs });
    //}


    //public async GetAuthToken(role: string) {
    //      const r = environment.roles.find(x => x.name === role);
    //      const data = `username=${r.user}&password=${r.password}&grant_type=password&client_id=${environment.audienceId}`;
    //      this.hs.append('Content-Type', 'application/x-www-form-urlencoded');
    //    //return await this.hcte.post(environment.authApiServerUrl, data, { headers: this.hs }).toPromise();
    //    return this.hcte.post(environment.authApiServerUrl, data, { headers: this.hs }).pipe();
    //}
}
